import { BuildClass, Do, fsmData } from '../../universal';
import { React, _ } from '../lib';
import { J2rCheckbox, J2rHelp, j2r, j2rtxt } from './component-react';
import { J2rListComponent } from './component-react-list';
import { ConditionalObject, setContextMenu } from './ui5';
export class J2rListGrid extends React.Component {
    static defaultProps = {
        cl: '',
        pk: x => x.ID,
        defaultSortingRev: false,
        readOnly: false,
        sortable: true,
        searchText: '',
    };
    listCmpt;
    colorScale;
    constructor(props) {
        super(props);
        this.onUpdate = this.onUpdate.bind(this);
        if (this.props.sortable && this.props.defaultSortingKey == null) {
            console.error('No default sorting key defined');
        }
        if (this.props.checkboxSelection && !this.props.multiple) {
            console.error('Cannot have checkbox selection without multi-select');
        }
        if (this.props.checkboxSelection && !this.props.multipleDefault) {
            console.error('Cannot have checkbox selection without multi-select default');
        }
        this.listCmpt = React.createRef();
        this.state = {
            sortKey: this.props.view?.sortKey ?? this.props.defaultSortingKey,
            sortRev: this.props.view?.sortRev ?? this.props.defaultSortingRev,
            hiddenFields: this.props.view?.hiddenFields ?? [],
            grouping: null,
            columnFilters: this.props.view?.columnFilters ?? {},
            groupingField: this.props.view?.groupingField ?? null,
            groupingFieldRev: this.props.view?.groupingFieldRev ?? null,
            colorBy: this.props.view?.colorBy,
            searchText: this.props.searchText ?? this.props.view?.searchText ?? '',
            value: this.props.value ??
                Do(() => {
                    if (this.props.multiple) {
                        return [];
                    }
                    return null;
                }),
        };
        _.assign(this.state, this.getGroupingDelta({
            groupingField: this.state.groupingField,
            groupingFieldRev: this.state.groupingFieldRev,
        }));
    }
    componentDidUpdate(prevProps) {
        const checkUpdateProp = (key_prop, key_state, def) => {
            if (!_.isEqual(this.props[key_prop], prevProps[key_prop])) {
                const val = this.props[key_prop] ?? def;
                if (!_.isEqual(val, this.state[key_state])) {
                    this.setState({ [key_state]: val });
                }
            }
        };
        const checUpdatePropView = (key_prop, key_state, def) => {
            if (!_.isEqual(this.props.view?.[key_prop], prevProps.view?.[key_prop])) {
                const val = this.props.view?.[key_prop] ?? def;
                if (!_.isEqual(val, this.state[key_state])) {
                    this.setState({ [key_state]: val });
                }
            }
        };
        checkUpdateProp('value', 'value');
        checkUpdateProp('defaultSortingKey', 'sortKey');
        checkUpdateProp('defaultSortingRev', 'sortRev');
        checUpdatePropView('sortKey', 'sortKey');
        checUpdatePropView('sortRev', 'sortRev');
        checUpdatePropView('hiddenFields', 'hiddenFields', []);
        checUpdatePropView('columnFilters', 'columnFilters', {});
        checUpdatePropView('groupingField', 'groupingField', null);
        checUpdatePropView('groupingFieldRev', 'groupingFieldRev', null);
        checUpdatePropView('colorBy', 'colorBy', null);
        if (prevProps.searchText !== this.props.searchText) {
            this.setState({ searchText: this.props.searchText });
        }
        if (prevProps.view?.searchText !== this.props.view?.searchText) {
            this.setState({ searchText: this.props.searchText });
        }
    }
    updateState(delta) {
        this.setState(delta, () => {
            this.onUpdate();
        });
    }
    onUpdate() {
        const fn = this.props.onUpdate ?? _.noop;
        fn(this.state.value, {
            sortKey: this.state.sortKey,
            sortRev: this.state.sortRev,
            hiddenFields: this.state.hiddenFields,
            columnFilters: this.state.columnFilters,
            groupingField: this.state.groupingField,
            groupingFieldRev: this.state.groupingFieldRev,
            colorBy: this.state.colorBy,
        });
    }
    render() {
        return j2r({
            tag: J2rListComponent,
            value: this.state.value,
            ref: this.listCmpt,
            onUpdate: (v) => {
                this.updateState({ value: v });
            },
            multiple: this.props.multiple,
            multipleDefault: this.props.multipleDefault,
            readOnly: this.props.readOnly,
            lazyRenderHeight: this.props.lazyRenderHeight,
            lazyThrottleMs: this.props.lazyThrottleMs,
            cl: BuildClass({
                [this.props.cl ?? '']: true,
                j2rlistgrid: true,
                'checkbox-selection': this.props.checkboxSelection ?? false,
            }),
            style: this.props.style,
            headingRow: this.buildHeadingRow(),
            items: this.buildItems(),
            sortable: this.props.sortableItems,
            disableFocusControl: this.props.disableFocusControl,
        });
    }
    buildHeadingRow() {
        const fieldsBySubRow = _.groupBy(this.props.fields, F => F.row ?? 1);
        const subRowKeys = fsmData(_.keys(fieldsBySubRow), {
            sort: x => +x,
            map: x => +x,
        });
        return {
            cl: BuildClass({
                'gridRow heading ': true,
                [this.props.clRow?.(null) ?? '']: true,
            }),
            children: subRowKeys.map(sr => ({
                key: sr,
                cl: BuildClass({
                    heading: true,
                    'sub-row gridRow': true,
                    [`sub-row-${sr}`]: true,
                }),
                children: _.compact(_.flatten([
                    ConditionalObject(sr == 1 && (this.props.checkboxSelection ?? false), () => this.buildCheckboxHeader()),
                    fsmData(this.props.fields, {
                        filter: F => (F.row ?? 1) == sr &&
                            !this.state.hiddenFields?.includes(F.key ?? F.lbl),
                        map: F => this.buildHeadingCell(F),
                    }),
                ])),
            })),
        };
    }
    buildCheckboxHeader() {
        return {
            tag: 'span',
            key: 'checkbox-selection',
            cl: 'checkbox-selection noselect',
            children: [
                {
                    tag: J2rCheckbox,
                    key: 'checkbox',
                    triggerClick: true,
                    value: Do(() => {
                        const values = _.sortBy(this.props.data.map(x => this.props.pk(x)));
                        return _.isEqual(values, _.sortBy(this.state.value));
                    }),
                    onClick: (e) => e.stopPropagation(),
                    onUpdate: (v) => {
                        const delta = (s) => ({
                            value: Do(() => {
                                if (v) {
                                    return s.value.concat(this.props.data.map(x => this.props.pk(x)));
                                }
                                return [];
                            }),
                        });
                        this.updateState(delta);
                    },
                },
            ],
        };
    }
    buildHeadingCell(F) {
        const key = F.key ?? F.lbl;
        let lblDesc = F.lblDesc ?? F.lbl;
        let { lbl } = F;
        const sortable = this.props.sortable &&
            (F.sortVal != null || F.text != null) &&
            (F.sortable ?? true);
        if (this.state.columnFilters[key] != null) {
            lblDesc += ' (filtered by value)';
            lbl += '*';
        }
        return {
            tag: 'span',
            key,
            cl: BuildClass({
                [(key ?? '').toLowerCase().replace(/[^a-z0-9]/g, '') ?? '']: true,
                'heading-cell-inner': true,
                [F.cl?.(null) ?? '']: true,
                'help-indicator': F.tooltipBubble ?? false,
                filtered: Boolean(this.state.columnFilters[key] != null),
                nosort: !sortable,
                sorted: Boolean(sortable && key === this.state.sortKey),
                'sort-asc': Boolean(sortable && key === this.state.sortKey && !this.state.sortRev),
                'sort-dsc': Boolean(sortable && key === this.state.sortKey && this.state.sortRev),
                grouped: key === this.state.groupingField,
                'group-asc': Boolean(key === this.state.groupingField && !this.state.grouping.reverse),
                'group-dsc': Boolean(key === this.state.groupingField && this.state.grouping.reverse),
            }),
            text: !F.tooltipBubble ? lbl : undefined,
            title: !F.tooltipBubble ? lblDesc : undefined,
            children: ConditionalObject(F.tooltipBubble ?? false, [
                {
                    key: 'lbl',
                    text: lbl,
                    title: lblDesc,
                },
                {
                    tag: J2rHelp,
                    key: 'help-tooltip',
                    title: lblDesc,
                },
            ]),
            onClick: Do(() => {
                if (key === this.state.groupingField) {
                    return () => {
                        this.updateState(s => ({
                            grouping: _.assign({}, s.grouping, {
                                reverse: !s.grouping.reverse,
                            }),
                        }));
                    };
                }
                else if (sortable) {
                    return () => {
                        this.updateState(s => ({
                            sortKey: key,
                            sortRev: Do(() => {
                                if (s.sortKey === key) {
                                    return !s.sortRev;
                                }
                                return F.sortReverseDefault ?? false;
                            }),
                        }));
                    };
                }
                return undefined;
            }),
            onMouseDown: (e) => {
                if (e.button === 1) {
                    this.updateState(s => this.getGroupingDelta(Do(() => {
                        if (key === s.groupingField) {
                            return {
                                groupingField: null,
                                groupingFieldRev: null,
                            };
                        }
                        return {
                            groupingField: key,
                            groupingFieldRev: false,
                        };
                    })));
                    return;
                }
            },
            onContextMenu: (e) => {
                e.preventDefault();
                this.headingCellContextMenu(e, F);
            },
        };
    }
    buildItems() {
        this.cacheColorScale();
        const groups = this.getGroupedRecords();
        const grouping = this.state.grouping ?? this.props.grouping;
        return _.compact(_.flattenDeep(_.map(groups, group => {
            const heading_gap = (groups.length > 1 || group.ID != null) && (grouping.gaps ?? true);
            const heading_row = (groups.length > 1 || group.ID != null) && group.Name != null;
            let total_rows = group.Records?.length ?? 0;
            total_rows += heading_gap ? 1 : 0;
            total_rows += heading_row ? 1 : 0;
            return [
                Do(() => {
                    if (heading_gap) {
                        return {
                            lazyRenderHeight: group.ID === groups[0]?.ID ? 0 : null,
                            getItem: () => ({
                                value: `listgrid-group-gap-${group.ID}`,
                                selectable: false,
                                cl: BuildClass({
                                    gridRow: true,
                                    'listgrid-group-heading-gap': true,
                                    'no-select-highlight': true,
                                    'hidden-grouping-row': group.ID === groups[0]?.ID,
                                    [this.props.clRow?.(null) ?? '']: true,
                                }),
                                children: [
                                    {
                                        tag: 'span',
                                        key: 'stub',
                                        dangerouslySetInnerHTML: {
                                            __html: '&nbsp;',
                                        },
                                    },
                                ],
                            }),
                        };
                    }
                    else if (heading_row) {
                        return {
                            lazyRenderHeight: 0,
                            getItem: () => ({
                                value: `listgrid-group-mod21-${group.ID}`,
                                selectable: false,
                                cl: 'gridRow hidden-grouping-row',
                            }),
                        };
                    }
                    return undefined;
                }),
                heading_row ? () => this.buildGroupHeadingRow(group) : undefined,
                this.buildItemsInnerGroup(group.Records ?? []),
                ConditionalObject(heading_row && groups.length > 1 && total_rows % 2 != 0, () => ({
                    lazyRenderHeight: 0,
                    getItem: () => ({
                        value: `listgrid-group-mod22-${group.ID}`,
                        selectable: false,
                        cl: 'gridRow hidden-grouping-row',
                    }),
                })),
            ];
        })));
    }
    buildItemsInnerGroup(records) {
        const sortingFunction = Do(() => {
            if (!this.props.sortable) {
                return () => 1;
            }
            const { sortKey } = this.state;
            let sortFn = null;
            _.forEach(this.props.fields, F => {
                const key = (F.key ?? F.lbl);
                if (key === sortKey) {
                    const fn = F.sortVal ?? F.text;
                    sortFn = fn != null ? fn : (record) => record[key];
                    return false;
                }
                return true;
            });
            if (sortFn != null) {
                return sortFn;
            }
            console.warn('No sorting value found for key: ', this.state.sortKey);
            return () => 1;
        });
        return fsmData(records, {
            sort: record => sortingFunction(record, this.state.sortRev ?? false),
            reverse: Boolean(this.state.sortRev && this.props.sortable),
            map: x => {
                if (_.isFunction(this.props.lazyRenderHeight)) {
                    return {
                        lazyRenderHeight: this.props.lazyRenderHeight(x),
                        getItem: () => this.buildItem(x),
                    };
                }
                return () => this.buildItem(x);
            },
        });
    }
    buildGroupHeadingRow(group) {
        return {
            value: `listgrid-group-${group.ID}`,
            selectable: false,
            cl: BuildClass({
                gridRow: true,
                'listgrid-group-heading': true,
                'no-select-highlight': true,
                [(this.props.clRow ?? (() => ''))(null)]: true,
            }),
            title: this.props.tooltipRow?.(null),
            children: _.compact(_.flatten([
                {
                    tag: 'span',
                    key: 'title',
                    children: [j2rtxt('txt', group.Name)],
                    title: `${group.Name} - ${group.Records?.length ?? 0}`,
                },
            ])),
        };
    }
    buildItem(record) {
        const fieldsBySubRow = _.groupBy(this.props.fields, F => F.row ?? 1);
        const subRowKeys = fsmData(_.keys(fieldsBySubRow), {
            sort: x => +x,
            map: x => +x,
        });
        const selectable = (this.props.selectable ?? (() => true))(record);
        return {
            value: this.props.pk(record),
            selectable: selectable,
            cl: BuildClass({
                gridRow: true,
                [(this.props.clRow ?? (() => null))(record) ?? '']: true,
            }),
            title: this.props.tooltipRow?.(record),
            children: subRowKeys.map(sr => ({
                key: sr,
                cl: BuildClass({
                    'sub-row gridRow': true,
                    [`sub-row-${sr}`]: true,
                }),
                children: _.compact(_.flatten([
                    ConditionalObject(sr == 1 && (this.props.checkboxSelection ?? false), () => ({
                        tag: 'span',
                        key: 'checkbox-selection',
                        cl: 'checkbox-selection',
                        children: [
                            ConditionalObject(selectable, {
                                tag: J2rCheckbox,
                                key: 'checkbox',
                                readOnly: true,
                                value: _.includes(this.state.value, this.props.pk(record)),
                            }),
                        ],
                    })),
                    fsmData(this.props.fields, {
                        filter: F => (F.row ?? 1) == sr &&
                            !this.state.hiddenFields?.includes(F.key ?? F.lbl),
                        map: F => ({
                            tag: 'span',
                            key: F.key ?? F.lbl,
                            style: this.buildColorStyle(F, record),
                            cl: BuildClass({
                                [(F.key ?? F.lbl ?? '')
                                    .toLowerCase()
                                    .replace(/[^a-z0-9]/g, '')]: true,
                                [F.cl?.(record) ?? '']: F.cl != null,
                            }),
                            children: this.buildCell(F, record),
                            title: Do(() => {
                                if (F.tooltip != null) {
                                    return F.tooltip(record);
                                }
                                return record[(F.key ?? F.lbl)];
                            }),
                            onClick: Do(() => {
                                if (F.onClick != null) {
                                    return (e) => {
                                        F.onClick?.(record, e);
                                    };
                                }
                                return undefined;
                            }),
                        }),
                    }),
                ])),
            })),
            onClick: Do(() => {
                if (this.props.onClick != null) {
                    return (e, def_ev) => {
                        this.props.onClick?.(record, e, def_ev);
                    };
                }
                return undefined;
            }),
            onContextMenu: (v, e) => {
                this.props.onContextMenu?.(v, e);
            },
        };
    }
    buildColorStyle(field, record) {
        if (this.state.colorBy == null ||
            this.state.colorBy !== (field.key ?? field.lbl)) {
            return null;
        }
        let val = (field.colorVal ?? field.sortVal ?? field.text)?.(record);
        if (val == null || isNaN(+val)) {
            return null;
        }
        val = +val;
        const scale = this.colorScale[1] - this.colorScale[0];
        const proportion = (val - this.colorScale[0]) / scale;
        const hsl_high_raw = field.colorScale?.high ?? {};
        const hsl_low_raw = field.colorScale?.low ?? {};
        const hsl_low = {
            h: hsl_low_raw.h ?? 0,
            s: hsl_low_raw.s ?? 100,
            l: hsl_low_raw.l ?? 75,
        };
        const hsl_high = {
            h: hsl_high_raw.h ?? 120,
            s: hsl_high_raw.s ?? 100,
            l: hsl_high_raw.l ?? 70,
        };
        const h = proportion * (hsl_high.h - hsl_low.h) + hsl_low.h;
        const s = proportion * (hsl_high.s - hsl_low.s) + hsl_low.s;
        const l = proportion * (hsl_high.l - hsl_low.l) + hsl_low.l;
        return { background: `hsl(${h},${s}%,${l}%)` };
    }
    buildCell(field, record) {
        if (field.display) {
            return [_.assign(field.display(record), { key: 'cmpt' })];
        }
        let text = null;
        text =
            field.text != null
                ? field.text(record)
                : record[(field.key ?? field.lbl)];
        text = String(text);
        if (!this.props.searchText) {
            return [
                {
                    tag: 'span',
                    key: 'text',
                    text,
                },
            ];
        }
        const startIndex = text.toLowerCase().indexOf(this.props.searchText.toLowerCase());
        if (startIndex === -1) {
            return [
                {
                    tag: 'span',
                    key: 'text',
                    text,
                },
            ];
        }
        const endIndex = startIndex + this.props.searchText.length;
        const parts = [
            text.substring(0, startIndex),
            text.substring(startIndex, endIndex),
            text.substring(endIndex, text.length),
        ];
        return [
            {
                tag: 'span',
                key: 'text-pre',
                text: parts[0],
            },
            {
                tag: 'span',
                key: 'text-mid',
                cl: 'highlight',
                text: parts[1],
            },
            {
                tag: 'span',
                key: 'text-post',
                text: parts[2],
            },
        ];
    }
    headingCellContextMenu(ev, field) {
        const hiddenFields = this.state.hiddenFields ?? [];
        setContextMenu({
            position: {
                x: ev.clientX,
                y: ev.clientY,
            },
            items: _.compact([
                {
                    label: 'Reset view',
                    icon: '/static/img/i8/material-outline-clear-filters.svg',
                    onClick: () => {
                        this.updateState({
                            grouping: null,
                            groupingField: null,
                            groupingFieldRev: null,
                            hiddenFields: [],
                            columnFilters: {},
                            sortKey: this.props.defaultSortingKey,
                            sortRev: this.props.defaultSortingRev,
                            colorBy: null,
                        });
                    },
                },
                {
                    label: 'Copy as text',
                    icon: '/static/img/i8/material-outline-copy.svg',
                    onClick: () => {
                        const lines = _.map(this.getFullTable(), x => x.join('\t'));
                        navigator.clipboard.writeText(lines.join('\n'));
                    },
                },
                this.props.sortable ? '---' : undefined,
                {
                    label: 'Sort ascending',
                    shortcut: 'LMB',
                    shortcutDesc: 'Left mouse button',
                    icon: '/static/img/i8/material-outline-ascending-sorting.svg',
                    hidden: !this.props.sortable,
                    onClick: () => {
                        this.updateState({
                            sortKey: field.key ?? field.lbl,
                            sortRev: false,
                        });
                    },
                },
                {
                    label: 'Sort descending',
                    icon: '/static/img/i8/material-outline-descending-sorting.svg',
                    hidden: !this.props.sortable,
                    onClick: () => {
                        this.updateState({
                            sortKey: field.key ?? field.lbl,
                            sortRev: true,
                        });
                    },
                },
                this.buildContextMenuSortBy(),
                '---',
                {
                    label: 'Group ascending',
                    shortcut: 'MMB',
                    shortcutDesc: 'Middle mouse button',
                    icon: '/static/img/i8/material-outline-ascending-sorting.svg',
                    onClick: () => {
                        this.updateState(this.getGroupingDelta({
                            groupingField: field.key ?? field.lbl,
                            groupingFieldRev: false,
                        }));
                    },
                },
                {
                    label: 'Group descending',
                    icon: '/static/img/i8/material-outline-descending-sorting.svg',
                    onClick: () => {
                        this.updateState(this.getGroupingDelta({
                            groupingField: field.key ?? field.lbl,
                            groupingFieldRev: true,
                        }));
                    },
                },
                this.buildContextMenuGroupBy(),
                '---',
                this.buildContextMenuFilterByValue(field),
                {
                    label: 'Hide column',
                    icon: '/static/img/i8/material-outline-closed-eye.svg',
                    onClick: () => {
                        this.updateState(s => ({
                            hiddenFields: s.hiddenFields?.concat(field.key ?? field.lbl) ?? [],
                        }));
                    },
                },
                {
                    label: 'Toggle columns...',
                    icon: '/static/img/i8/material-outline-delete-column.svg',
                    items: _.flatten([
                        {
                            label: 'Show All',
                            dontClose: true,
                            icon: () => {
                                if (hiddenFields.length === 0) {
                                    return '/static/img/i8/material-outline-eye.svg';
                                }
                                return '';
                            },
                            onClick: () => {
                                this.updateState(s => ({
                                    hiddenFields: Do(() => {
                                        if ((s.hiddenFields?.length ?? 0) === 0) {
                                            return this.props.fields?.map(F => F.key ?? F.lbl);
                                        }
                                        return [];
                                    }),
                                }));
                            },
                        },
                        '---',
                        fsmData(this.props.fields, {
                            map: F => ({
                                label: F.lblLong ?? F.lbl,
                                labelDesc: F.lblDesc ?? F.lbl,
                                icon: () => {
                                    if (hiddenFields.includes(F.key ?? F.lbl)) {
                                        return null;
                                    }
                                    return '/static/img/i8/material-outline-eye.svg';
                                },
                                dontClose: true,
                                onClick: () => {
                                    this.updateState(s => ({
                                        hiddenFields: Do(() => {
                                            if (s.hiddenFields?.includes(F.key ?? F.lbl)) {
                                                return s.hiddenFields.filter(x => (F.key ?? F.lbl) !== x);
                                            }
                                            return (s.hiddenFields?.concat(F.key ?? F.lbl) ??
                                                []);
                                        }),
                                    }));
                                },
                            }),
                        }),
                    ]),
                },
                '---',
                {
                    label: 'Colour by value',
                    icon: '/static/img/i8/material-outline-paint-palette.svg',
                    onClick: () => {
                        this.updateState(s => {
                            const k = field.key ?? field.lbl;
                            if (s.colorBy === k) {
                                return { colorBy: null };
                            }
                            return { colorBy: k };
                        });
                    },
                },
            ]),
        });
    }
    buildContextMenuSortBy() {
        return {
            label: 'Sort By...',
            icon: '/static/img/i8/material-outline-sort.svg',
            hidden: !this.props.sortable,
            items: fsmData(this.props.fields, {
                filter: F => (F.sortVal != null || F.text != null) && (F.sortable ?? true),
                map: F => ({
                    label: F.lblLong ?? F.lbl,
                    labelDesc: F.lblDesc ?? F.lbl,
                    dontClose: true,
                    icon: () => {
                        if (this.state.sortKey !== (F.key ?? F.lbl)) {
                            return null;
                        }
                        else if (this.state.sortRev) {
                            return '/static/img/i8/material-outline-descending-sorting.svg';
                        }
                        return '/static/img/i8/material-outline-ascending-sorting.svg';
                    },
                    onClick: () => {
                        this.updateState(s => ({
                            sortKey: F.key ?? F.lbl,
                            sortRev: Do(() => {
                                if (s.sortKey === (F.key ?? F.lbl)) {
                                    return !s.sortRev;
                                }
                                return F.sortReverseDefault ?? false;
                            }),
                        }));
                    },
                }),
            }),
        };
    }
    buildContextMenuGroupBy() {
        return {
            label: 'Group by...',
            icon: '/static/img/i8/material-outline-group-objects.svg',
            items: _.flatten([
                {
                    label: 'None',
                    dontClose: true,
                    icon: () => {
                        if (this.state.groupingField != null) {
                            return null;
                        }
                        if (this.props.grouping == null && this.state.grouping != null) {
                            return null;
                        }
                        if (this.props.grouping != null && this.state.grouping == null) {
                            return null;
                        }
                        return '/static/img/i8/material-outline-checkmark.svg';
                    },
                    onClick: () => {
                        if (this.props.grouping == null) {
                            this.updateState(this.getGroupingDelta({
                                groupingField: null,
                                groupingFieldRev: null,
                                grouping: null,
                            }));
                        }
                        else {
                            this.updateState(this.getGroupingDelta({
                                groupingField: null,
                                groupingFieldRev: null,
                                grouping: {
                                    key: () => 1,
                                    name: () => null,
                                    sort: () => 1,
                                    gaps: false,
                                },
                            }));
                        }
                    },
                },
                {
                    label: 'Default',
                    hidden: this.props.grouping == null,
                    icon: () => {
                        if (this.state.grouping == null) {
                            return '/static/img/i8/material-outline-checkmark.svg';
                        }
                        return '';
                    },
                    dontClose: true,
                    onClick: () => {
                        this.updateState(this.getGroupingDelta({
                            groupingField: null,
                            groupingFieldRev: null,
                            grouping: null,
                        }));
                    },
                },
                '---',
                fsmData(this.props.fields, {
                    filter: F => (F.groupVal ?? F.text) != null,
                    map: F => ({
                        label: F.lblLong ?? F.lbl,
                        labelDesc: F.lblDesc ?? F.lbl,
                        icon: () => {
                            if (this.state.groupingField !== (F.key ?? F.lbl)) {
                                return null;
                            }
                            else if (this.state.grouping.reverse) {
                                return '/static/img/i8/material-outline-descending-sorting.svg';
                            }
                            return '/static/img/i8/material-outline-ascending-sorting.svg';
                        },
                        dontClose: true,
                        onClick: () => {
                            this.updateState(this.getGroupingDelta({
                                groupingField: F.key ?? F.lbl,
                                groupingFieldRev: Do(() => {
                                    if (this.state.groupingField !== (F.key ?? F.lbl)) {
                                        return false;
                                    }
                                    return !this.state.groupingFieldRev;
                                }),
                            }));
                        },
                    }),
                }),
            ]),
        };
    }
    buildContextMenuFilterByValue(field) {
        return {
            label: 'Filter column',
            icon: '/static/img/i8/material-outline-filter.svg',
            hidden: field.text == null,
            items: () => {
                const values_fixed = field.filterValues?.() ?? [];
                let values_found = _.uniq(fsmData(this.props.data, {
                    sort: x => (field.sortVal ?? field.text)?.(x) ?? null,
                    map: x => field.text?.(x) ?? null,
                }));
                values_found = _.filter(values_found, x => !values_fixed.includes(x));
                const values = _.uniq(_.concat(values_found, values_fixed));
                let existing = this.state.columnFilters[field.key ?? field.lbl] ?? null;
                const tick = '/static/img/i8/material-outline-checkmark.svg';
                return _.flatten([
                    {
                        label: 'Select All',
                        icon: existing == null ? tick : undefined,
                        dontClose: true,
                        onClick: () => {
                            this.updateState(s => {
                                const c = _.clone(s.columnFilters);
                                const k = field.key ?? field.lbl;
                                c[k] = c[k] != null ? null : [];
                                return { columnFilters: c };
                            });
                        },
                    },
                    '---',
                    _.map(values, v => ({
                        label: String(v),
                        icon: existing == null || existing.includes(v) ? tick : undefined,
                        dontClose: true,
                        onClick: () => {
                            this.updateState(s => {
                                const c = _.clone(s.columnFilters);
                                existing = c[field.key ?? field.lbl];
                                if (existing == null) {
                                    existing = values.filter(x => x !== v);
                                }
                                else if (existing.includes(v)) {
                                    existing = existing.filter((x) => x !== v);
                                }
                                else {
                                    existing = existing.concat(v);
                                }
                                if (_.difference(values, existing).length === 0) {
                                    existing = null;
                                }
                                c[field.key ?? field.lbl] = existing;
                                return { columnFilters: c };
                            });
                        },
                    })),
                ]);
            },
        };
    }
    getGroupedRecords() {
        const grouping = this.state.grouping ?? this.props.grouping ?? {};
        const records = this.getFilteredRecords();
        const groups = _.groupBy(records, x => JSON.stringify((grouping.key ?? _.noop)(x) ?? null));
        const getGroupObj = (k) => {
            const items = groups[JSON.stringify(k)];
            return {
                ID: k,
                Name: grouping.name?.(k, items) ?? null,
                Records: items,
            };
        };
        let group_keys = _.keys(groups).map(x => JSON.parse(x));
        group_keys = _.sortBy(group_keys, gk => {
            const fn = grouping.sort ?? ((x) => x.Name);
            return fn(getGroupObj(gk));
        });
        if (grouping.reverse) {
            _.reverse(group_keys);
        }
        return _.map(group_keys, x => getGroupObj(x));
    }
    getFilteredRecords(searchText) {
        if (searchText == null) {
            searchText = this.props.searchText;
        }
        const filterSearchText = Do(() => {
            if (!searchText) {
                return () => true;
            }
            const textFns = fsmData(this.props.fields, {
                filter: F => F.text != null && (F.searchable ?? true),
                map: F => (x) => String(F.text?.(x) ?? '').toLowerCase(),
            });
            const search_text = searchText.toLowerCase();
            return record => {
                let found = false;
                _.forEach(textFns, fn => {
                    if (fn(record).indexOf(search_text) !== -1) {
                        found = true;
                        return false;
                    }
                    return true;
                });
                return found;
            };
        });
        const filterColumnValues = Do(() => {
            const cols = fsmData(this.props.fields, {
                filter: F => {
                    const values = this.state.columnFilters[F.key ?? F.lbl];
                    return values != null && F.text != null;
                },
                map: F => ({
                    getValue: record => F.text?.(record) ?? null,
                    values: this.state.columnFilters[F.key ?? F.lbl],
                }),
            });
            if (cols.length === 0) {
                return () => true;
            }
            return record => {
                let failed = false;
                _.forEach(cols, x => {
                    const needle = x.getValue(record);
                    if (!x.values.includes(needle)) {
                        failed = true;
                        return false;
                    }
                    return true;
                });
                return !failed;
            };
        });
        return _.filter(this.props.data, record => {
            if (!filterSearchText(record)) {
                return false;
            }
            if (!filterColumnValues(record)) {
                return false;
            }
            return true;
        });
    }
    getFullTable() {
        let heading_row = _.compact(_.flatMap(this.buildHeadingRow()?.children, x => x.children ?? []) ?? []).map((x) => x.text);
        if (heading_row == null) {
            heading_row = [];
        }
        let rows = this.buildItems().map((x) => {
            const rowFn = x?.getItem != null ? x.getItem : x;
            const row = _.isFunction(rowFn) ? rowFn() : rowFn;
            console.log({ row });
            return (_.flatMap(row?.children, x => x.children ?? []) ?? []).map(x => x?.children?.[0]?.text ?? null);
        });
        if (rows == null) {
            rows = [];
        }
        return _.concat([heading_row], rows);
    }
    getElement() {
        return this.listCmpt.current?.listElement.current;
    }
    getGroupingDelta({ groupingField, groupingFieldRev, grouping }) {
        return {
            groupingField,
            groupingFieldRev,
            grouping: grouping ??
                Do(() => {
                    const F = fsmData(this.props.fields, {
                        filter: F => groupingField === (F.key ?? F.lbl),
                        takeFirst: true,
                    });
                    if (F == null) {
                        return null;
                    }
                    const keyFn = F.groupVal ?? F.sortVal ?? F.text;
                    if (keyFn == null) {
                        return {
                            key: () => 1,
                            name: () => null,
                            sort: () => 1,
                            gaps: false,
                        };
                    }
                    return {
                        key: keyFn,
                        name: F.groupName ?? ((_k, x) => F.text(x[0])),
                        sort: F.groupSort ?? (x => (F.sortVal ?? F.text)(x.Records[0])),
                        reverse: groupingFieldRev,
                    };
                }),
        };
    }
    cacheColorScale() {
        if (this.state.colorBy == null) {
            this.colorScale = [null, null];
            return;
        }
        const fn = fsmData(this.props.fields, {
            filter: F => this.state.colorBy === (F.key ?? F.lbl),
            map: F => F?.colorVal ?? F?.sortVal ?? F?.text ?? _.noop,
            takeFirst: true,
        });
        const vals = _.map(this.props.data, x => +fn(x) || null);
        this.colorScale = [_.min(vals), _.max(vals)];
    }
}
//# sourceMappingURL=component-react-listgrid.js.map